import PropTypes from "prop-types";
import React from "react";

import Icon from "../interface/Icon";

const ModalTabButton = props => (
  <div
    className={`modalTabButton ${props.active ? "active" : ""} ${props.disabled ? "disabled" : ""}`}
    onClick={props.disabled ? null : props.onClick}
    title={props.label}
  >
    <Icon icon={props.icon} />
    <span>{props.label}</span>
  </div>
);

ModalTabButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  icon: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  active: PropTypes.bool.isRequired,
  disabled: PropTypes.bool
};

export default ModalTabButton;
